// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {useContext, useState, useEffect} from 'react';
import {Settings_context} from '../settings_ctx';
import {img_url} from '../ui/img_url';
import {Editor} from '../../../shared/editor/editor';
import {Button} from '../../../shared/button';
import styles from './contact_us.module.less';
import cn from 'classnames';
import {use_screen} from '../lib/screen_util';

interface i_contact_us_props {
    title: string;
    subtitle: string;
    cta: string;
    link: string;
}

export const Contact_us = (props: i_contact_us_props)=>{
    const {title, subtitle, cta, link} = props;
    const {theme} = useContext(Settings_context);
    const {screen} = use_screen();
    const [img_src, set_image_src] = useState('');
    useEffect(()=>{
        const src = screen=='xs' || screen=='sm' ?
            img_url('about/contact_us_mobile.png') :
            img_url('about/contact_us.png');
        set_image_src(src);
    }, [screen, img_url]);
    return <div className={styles.talk_to_us_section}>
      <div className={styles.talk_to_us_content_wrapper}>
        <div className={cn([theme.container, styles.talk_to_us_content])}>
          <h3>{title}</h3>
          <p className={cn([theme.p2, styles.subtitle])}>{subtitle}</p>
          <div className={styles.button_container}>
            <Button to={link} caption={cta} />
          </div>
        </div>
      </div>
      <img className={styles.talk_to_us_image}
        src={img_src} alt="Chat support" />
    </div>;
};

interface i_contact_us_editors_props {
  value: i_contact_us_props;
  on_change: (new_value: i_contact_us_props)=>void;
}

export const Contact_us_editor = (props: i_contact_us_editors_props)=>{
  const {value, on_change} = props;
  return <Editor
    value={value} on_change={on_change}
    editors={[
      {key: 'title', label: 'Title', type: 'text'},
      {key: 'subtitle', label: 'Subtitle', type: 'text'},
      {key: 'link', label: 'Link', type: 'text'},
      {key: 'cta', label: 'CTA', type: 'text'},
    ]}/>;
};
